import $ from 'jquery';
import _ from 'underscore';
import Cache from 'root/cache';
import Util from 'root/module/util';
import UI from 'root/ui';
import View from 'view/base';

export default View.extend({
    events: {
        'keyup input[name="search"]'     : 'onAddByEnterKey',
        'click .dropdown-session-tag li' : 'onSelectTag',
        'click .new-tag-add > button'    : 'onAddTag'
    },

    dom_handlers: {
        onAddByEnterKey: function(e) {
            var tag_name = $(e.currentTarget).val().trim();
            var exists = !tag_name || this.session_tags.indexOf(tag_name) !== -1;

            this.$el.find('.new-tag-add').toggle(!exists);

            if (exists) {
                return;
            } else {
                this.$el.find('.new-tag-name').text(tag_name);

                // Enter key
                if (e.keyCode === 13) {
                    this.session_tags.push(tag_name);
                    this.selected_tags.push(tag_name);
                    this.render();
                }
            }
        },

        onSelectTag: function(e) {
            var tag_name = $(e.target).data('val').toString();
            var index = this.selected_tags.indexOf(tag_name);

            if (index === -1) {
                this.selected_tags.push(tag_name);
            } else {
                this.selected_tags.splice(index, 1);
            }

            this.render();
        },

        onAddTag: function(e) {
            var tag_name = this.$el.find('input[name="search"]').val().trim();

            this.session_tags.push(tag_name);
            this.selected_tags.push(tag_name);
            this.render();
        }
    },

    events_handlers: {
        onSubmit: function() {
            Cache.app.request({
                action: 'session_recording/update',
                data: {
                    id: this.model.id,
                    tags: this.selected_tags.length ? this.selected_tags : ['']
                },
                success: (response) => {
                    this.model.set(response);
                    UI.success('Session tag updated');
                },
            });
        },
    },

    initialize: function(options) {
        this.selected_tags = this.model.get('tag') ? this.model.get('tag').split(',') : [];
        this.session_tags = Util.arrayUnique([...options.session_tags, ...this.selected_tags]);

        this.listenTo(this, 'submit', this.events_handlers.onSubmit);
    },

    render: function() {
        var selected_tags = '';
        var tag_options = '';

        this.selected_tags.forEach((tag_name) => {
            selected_tags += '<span class="badge-primary-invert badge-small font-weight-medium">' + Util.htmlEntities(tag_name) + '</span>';
        });

        this.session_tags.map((tag_name) => {
            tag_options += '<li data-val="' + Util.htmlEntities(tag_name) + '"' + (this.selected_tags.indexOf(tag_name) === -1 ? '' : ' class="selected"') + '>' + Util.htmlEntities(tag_name) + '</li>';
        });

        var content =
            '<div class="button-dropdown button-dropdown-full">' +
                '<button type="button" class="dropdown-button dropdown-select dropdown-select-medium dropdown-select-multiple">' +
                    (selected_tags || '<span class="placeholder-text">Select...</span>') +
                '</button>' +
                '<div>' +
                    '<div class="dropdown-search">' +
                        '<input name="search" type="text" class="solid compact" maxlength="20" placeholder="Add tag...">' +
                    '</div>' +
                    '<ul class="dropdown dropdown-session-tag' + (tag_options ? ' dropdown-select' : '') + '" data-empty="No tags found">' +
                        (tag_options || '<li class="disabled">No tags added</li>') +
                    '</ul>' +
                    '<div class="new-tag-add" style="display:none;">' +
                        '<button type="button" class="text-link small"><i class="fa-solid fa-plus margin-right-4"></i>Create new tag: <span class="new-tag-name"></span></button>' +
                    '</div>' +
                '</div>' +
            '</div>';

        this.$el.html(content);

        return this;
    }
});